var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 33,
  viewBox: "0 0 32 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 31.5,
  y: 32,
  width: 31,
  height: 31,
  rx: 15.5,
  transform: "rotate(-180 31.5 32)",
  fill: "white"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 31.5,
  y: 32,
  width: 31,
  height: 31,
  rx: 15.5,
  transform: "rotate(-180 31.5 32)",
  stroke: "#4585FF"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.1965 16.0295L15.3825 9.17181L16.0501 8.5L24 16.4997L16.0501 24.5L15.3825 23.7938L22.1936 16.9706H8.00023V16.0295H22.1965Z",
  fill: "#4585FF"
})));
export default SvgIconArrow;